'use client';

import { useEffect } from 'react';
import { yaNative } from '@weberus/ui/utils/ya-native';

const WebviewControlGuard = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!yaNative.isEnabled) return;

    const html = document.documentElement;
    const body = document.body;

    html.classList.add('webview-no-overscroll');
    body.classList.add('webview-no-overscroll', 'webview-no-select', 'webview-no-callout');

    return () => {
      html.classList.remove('webview-no-overscroll');
      body.classList.remove('webview-no-overscroll', 'webview-no-select', 'webview-no-callout');
    };
  }, []);

  return null;
};

export default WebviewControlGuard;
